import CertificationItem from '../../../../../../components/Cards/CardComponents/CertificationItem'
import { Certification } from '../../../../../../types/certification'

interface CertificationSectionProps {
  certifications: Certification[]
}

export function CertificationSection({ certifications }: CertificationSectionProps) {
  if (!certifications?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Certifications</h2>
      <div className="space-y-8">
        {certifications.map((certification, index) => (
          <CertificationItem key={index} certification={certification} />
        ))}
      </div>
    </div>
  )
}
